'use client'
import { notifyAddToCartAction } from '../actions/notify-add-to-cart'

export default function useNotifyAddToCart() {
  async function notify(ticket: string) {
    return await notifyAddToCartAction(ticket)
  }
  return (ticket: string) => notify(ticket)
}
